import * as React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  Container,
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Tooltip,
} from "@mui/material";
import { Page } from "../components/Page";
import { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";
import { getCheckInOrders, getCurrentUser } from "../api-config/config";
import DateRangeComponent from "../components/DateRangePicker";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { voucherView } from "../utils/miscellaneous";
import moment from "moment";

function PendingListGrid() {
  const [checkinlist, setCheckinlist] = useState([] as any);
  const [dynamicRows, setDynamicRows] = useState([] as any);
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  function onSetRange(value: any) {
    console.log(value);
    setRange(value);
  }
  function searchWithDateRange() {
    const startDateString = `${range.startDate.getFullYear()}-${
      range.startDate.getMonth() + 1
    }-${range.startDate.getDate()}`;
    const endDateString = `${range.endDate.getFullYear()}-${
      range.endDate.getMonth() + 1
    }-${range.endDate.getDate()}`;
    fetchCheckinOrder(startDateString, endDateString);
  }
  function fetchCheckinOrder(startDateString: any, endDateString: any) {
    getCheckInOrders(
      startDateString,
      endDateString,
      loggedUser?.hotel_code
    ).then((response: any) => {
      setCheckinlist(response.data);
      getRows(response.data);
    });
  }

  function isDateInRange(dateToCheck: any, startDate: any, endDate: any) {
    const checkDate = new Date(dateToCheck);
    checkDate.setHours(checkDate.getHours() - 5);
    checkDate.setMinutes(checkDate.getMinutes() - 30);
    const rangeStartDate = new Date(startDate);
    const rangeEndDate = new Date(endDate);

    console.log(
      checkDate,
      rangeStartDate,
      rangeEndDate,
      "condition ----------"
    );

    return checkDate >= rangeStartDate && checkDate <= rangeEndDate;
  }

  useEffect(() => {
    const getObj = getDateRange(new Date(), new Date());
    const start = new Date(getObj.start);
    const end = new Date(getObj.end);
    const startDateString = `${start.getFullYear()}-${
      start.getMonth() + 1
    }-${start.getDate()}`;
    const endDateString = `${end.getFullYear()}-${
      end.getMonth() + 1
    }-${end.getDate()}`;
    fetchCheckinOrder(startDateString, endDateString);
  }, []);
  const loggedUser = getCurrentUser();
  function getDateRange(sDate: any, eDate: any) {
    const currentMonth = sDate.getMonth();
    return {
      start: sDate.setMonth(currentMonth - 1),
      end: eDate.setMonth(currentMonth + 1),
    };
  }
  function getRows(data: any) {
    const allRows = [] as any;
    let id = 1;
    data.forEach((listData: any, key: any) => {
      if (listData.booking_status === "pending") {
        if (isDateInRange(listData.from_date, range.startDate, range.endDate)) {
          const date1 = new Date(listData.from_date);
          const month1 = date1.toLocaleString("default", { month: "short" });
          const date2 = new Date(listData.to_date);
          const month2 = date2.toLocaleString("default", { month: "short" });
          const diffDays = date2.getDate() - date1.getDate();
          const obj = {
            id: id++,
            resId: listData.booking_id,
            guestEmail: listData.email,
            guestName: listData.guest_first_name,
            guestMobile: listData.mobile_number,
            stayDuration: `${date1.getDate()} ${month1}`,
            roomType: listData.room_booking_info.room_name,
            roomNo: listData.room_booking_info.pms_room_no,
            pax: `${listData?.no_of_adults}(A)0(C)`,
            status: listData.booking_status,
            ratePlan:listData.room_booking_info.pms_rate_plan_name,
            amount: listData.gross_amount,
            guest_id: listData?.guest_id,
          };
          allRows.push(obj);
        }
      }
    });
    allRows.reverse();
    setDynamicRows([...allRows]);
    console.log("dynamicRows", setDynamicRows);
  }
  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      headerClassName: "super-app-theme--header",
      editable: true,
    },

    {
      field: "roomType",
      flex: 1,
      headerName: "Room#/Type",
      width: 140,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "roomNo",
      flex: 1,
      headerName: "Room No",
      headerClassName: "super-app-theme--header",
      width: 110,
      editable: true,
    },
    {
      field: "guestName",
      flex: 1,
      headerName: "Guest Name",
      // width: 200,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "guestEmail",
      flex: 1.5,
      headerName: "Guest email",
      // width: 200,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "guestMobile",
      flex: 1,
      headerName: "Mobile",
      // width: 100,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "stayDuration",
      flex: 1,
      headerName: "Arrival Dates",
      width: 200,
      editable: true,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "pax",
      flex: 1,
      headerName: "Pax",
      width: 90,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "status",
      flex: 1,
      headerName: "Status",
      width: 110,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "ratePlan",
      flex: 1,
      headerName: "Rate Plan",
      width: 110,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "amount",
      flex: 1,
      headerName: "Amount",
      width: 110,
      editable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "Action",
      width: 100,

      renderCell: (cellValues) => {
        return (
          <span
            style={{ marginLeft: "20px", marginRight: "20px" }}
            onClick={(event) => {
              voucherView(cellValues.row);
            }}
          >
            <Button
              type="button"
              className="bg-sky-600 hover:bg-sky-400 text-stone-50"
            >
              View
            </Button>
          </span>
        );
      },
      headerClassName: "super-app-theme--header",
    },
  ];

  return (
    <Box
      sx={{
        height: 423,
        width: "inherit",
        marginTop: 4,
        "& .super-app-theme--header": {
          backgroundColor: "#1976d2",
          color: "white",
        },
      }}
    >
      <p className="m-2.5">Select Date Range</p>
      <div className="flex justify-between p-2">
        <Stack direction="row" spacing={1} sx={{ justifyContent: "start" }}>
          <div className="border">
            <DateRangeComponent
              range={range}
              onSetRange={onSetRange}
              isShowPastDate={true}
            />
          </div>
          <Button
            type="button"
            onClick={() => searchWithDateRange()}
            className="bg-sky-600 hover:bg-sky-400 text-stone-50"
          >
            Search
          </Button>
        </Stack>
        <div className="flex justify-end mx-4">
          <CSVLink data={dynamicRows} filename={"expected-arrival-list.csv"}>
            <Tooltip title="Download Excel">
              {/* <FileDownloadIcon></FileDownloadIcon> */}
              <Button
                type="button"
                className="bg-sky-600 hover:bg-sky-400 text-stone-50"
              >
                Download
              </Button>
            </Tooltip>
          </CSVLink>
        </div>
      </div>

      <DataGrid
        autoHeight
        rows={dynamicRows}
        columns={columns}
        rowsPerPageOptions={[10, 50, 100]}
        checkboxSelection
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Box>
  );
}

export default function PendingList() {
  return (
    <>
      <Page title="Home">
        <Container maxWidth="xl" sx={{ padding: "0 !important" }}>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              color: "#0323f8",
              marginLeft: 10,
              fontWeight: 600,
              fontSize: 22,
            }}
          >
            Expected Arrival Report
          </Typography>
          <PendingListGrid />
        </Container>
      </Page>
    </>
  );
}
